export const showMyData = process.env.REACT_APP_MIS_DATOS;
export const showMyPurchases = process.env.REACT_APP_MIS_COMPRAS;
export const showMyTickets = process.env.REACT_APP_MIS_SOLICITUDES;
export const showGiftcardBalance = process.env.REACT_APP_SALDO_GIFTCARD;
export const showMyClubs = process.env.REACT_APP_MIS_CLUBES;
export const showMyPoints = process.env.REACT_APP_MIS_PUNTOS;
export const showContactUs = process.env.REACT_APP_CONTACTANOS;
export const showReportIssue = process.env.REACT_APP_REPORT_ISSUE;
export const showReportIssueNoProduct =
  process.env.REACT_APP_REPORT_ISSUE_NO_PRODUCT;
export const showAdvanceRequest = process.env.REACT_APP_SOLICITUD_AVANCE;
export const showReportIssueDispatchDate =
  process.env.REACT_APP_REPORT_ISSUE_CHANGE_DISPATCH_DATE;
export const showReportIssueAuthorizeThird =
  process.env.REACT_APP_REPORT_ISSUE_CHANGE_AUTHORIZE_THIRD;
export const showReportIssueDispatchAddress =
  process.env.REACT_APP_REPORT_ISSUE_CHANGE_DISPATCH_ADDRESS;
export const showReportIssueGoldSilver =
  process.env.REACT_APP_REPORT_ISSUE_GOLD_SILVER;
